import { Routes, Route } from 'react-router-dom';
import { ProductsProvider } from '../context/ProductsProvider';

import Music from './Pages/Music';
import About from './Pages/About';
import Arrangements from './Pages/Arrangements';
import Commissions from './Pages/Commissions';
import Contact from './Pages/Contact';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsOfService from './Pages/TermsOfService';
import Page404 from './Pages/Page404';
import Store from './Store/Store';
import Return from './Store/ReturnPage';
import Layout from './Layout';

const MusicNavigator = () => {
  return (
    <ProductsProvider>
      <Routes>
        <Route path="/" element={<Layout><Music /></Layout>} />
        <Route path="about" element={<Layout><About /></Layout>} />
        <Route path="work" element={<Layout fullWidth={true}><Arrangements /></Layout>} />
        <Route path="store" element={<Store />} />
        <Route path="store/:id" element={<Store />} />
        <Route path="checkout/success" element={<Store />} />
        <Route path="checkout/return" element={<Return />} />
        <Route path="commissions" element={<Layout><Commissions /></Layout>} />
        <Route path="contact" element={<Layout><Contact /></Layout>} />
        <Route path="privacyPolicy" element={<Layout><PrivacyPolicy /></Layout>} />
        <Route path="termsOfService" element={<Layout><TermsOfService /></Layout>} />
        <Route path="*" element={<Layout><Page404 /></Layout>} />
      </Routes>
    </ProductsProvider>
  )
}

export default MusicNavigator;